<template>
  <div class="purchase_order">
    <!-- main frame -->
    <v-container grid-list-md fluid>
      <!-- part 1 PO detail  -->
      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10" color="blue-grey lighten-5">
            <!-- <v-card-title>
              <v-icon large left>zoom_out_map</v-icon>
              <span class="title font-weight-heavy">Create DO</span>
            </v-card-title>-->

            <v-card-text>
              <v-layout wrap row class="pa-0">
                <!-- DO create date -->
                <v-flex xs2>
                  <v-menu
                    lazy
                    :close-on-content-click="true"
                    v-model="date_box"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Date"
                      v-model="date"
                      persistent-hint
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="date" @input="date_box = false" no-title actions></v-date-picker>
                  </v-menu>
                </v-flex>
                <!-- farmer selection  -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="farmer"
                    :items="farmerList"
                    item-text="name"
                    item-value="id"
                    label="Farmer"
                    ref="farmer"
                    persistent-hint
                    return-object
                    small-chips
                  ></v-autocomplete>
                </v-flex>
                <!--  driver selection  -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="driver"
                    :items="driverList"
                    item-text="username"
                    item-value="id"
                    label="Fetch by (may leave blank)"
                    ref="driver"
                    persistent-hint
                    return-object
                    small-chips
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-row>
                    <v-btn-toggle v-model="basket_control_type" mandatory>
                      <v-btn text value="farmer_return">
                        <span class="hidden-sm-and-down">farmer return Empty Basket</span>
                      </v-btn>
                      <v-btn text value="driver_send">
                        <span class="hidden-sm-and-down">Driver Give Empty Basket to Farm</span>
                      </v-btn>
                    </v-btn-toggle>
                  </v-row>

                  <v-text-field
                    v-model="basket_quantity"
                    v-on:change="basket_quantity = Math.max(Math.min(Math.round(basket_quantity), 9999999), 0)"
                    ref="basket_q"
                    type="number"
                    label="quantity (may ingore)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    type="number"
                    outline
                    v-model="sewa"
                    label="sewa price"
                    placeholder="0.2"
                  ></v-text-field>
                </v-flex>

                   <v-flex xs2>
                  <v-text-field
                    outline
                    v-model="ref_invoice"
                    label="Ref (invoice)"
                    placeholder="54321"
                  ></v-text-field>
                </v-flex>
                <!-- button create do  -->
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- part 2 DO item -->
      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <!--  insert item into DO -->
              <v-layout wrap row>
                <!--  Select Product -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="product"
                    :items="productList"
                    item-text="product_code_name"
                    item-value="id"
                    v-on:change="checkingProudctType()"
                    v-on:keyup.enter="checkingProudctType(),VegeNext()"
                    label="Vege"
                    ref="product"
                    chips
                    return-object
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ item.product_code_name }} &nbsp; &nbsp;
                      <v-avatar size="38">
                        <img :src="(baseUrl+'/product/vege_img/'+item.picture)" />
                      </v-avatar>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <!--  Select Grade -->
                <v-flex xs1 v-if="setting_grade == true">
                  <v-autocomplete
                    v-model="grade"
                    :items="gradeList"
                    item-text="name"
                    item-value="name"
                    v-on:keyup.enter="GradeNext()"
                    label="Grade"
                    ref="grade"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!--  Select Location -->
                <!-- <v-flex xs1 v-if="setting_location == true">
                  <v-autocomplete
                    v-model="location"
                    :items="locationList"
                    item-text="name"
                    item-value="name"
                    v-on:keyup.enter="LocationNext()"
                    label="Location"
                    ref="location"
                    chips
                  ></v-autocomplete>
                </v-flex> -->

                <!-- Type Price -->
                <v-flex xs1 v-if="setting_price == true">
                  <v-text-field
                    v-model="price"
                    v-on:keyup.enter="PriceNext();"
                    v-on:change="price = Math.max(Math.min(price, 9999999), 0)"
                    ref="price"
                    type="number"
                    label="Price"
                    box
                  ></v-text-field>
                </v-flex>
                <!--  Type Weight -->
                <v-flex xs2>
                  <v-text-field
                    v-if="product_type_need_weight==true"
                    v-model="weight"
                    v-on:keyup.enter="WeightNext()"
                    v-on:change="weight = Math.max(Math.min(weight, 9999999), 0.1)"
                    @keydown.tab.prevent="tabNext()"
                    @focus="$event.target.select()"
                    type="number"
                    ref="weight"
                    label="weight(kg)"
                    box
                  ></v-text-field>
                </v-flex>

                <!--  Type Quantity -->
                <v-flex xs2>
                  <v-text-field
                    v-model="quantity"
                    v-on:keyup.enter="QuantityNext()"
                    v-on:change="quantity = Math.max(Math.min(Math.round(quantity), 9999999), 1)"
                    @keydown.tab.prevent="tabNext()"
                    @focus="$event.target.select()"
                    ref="qty"
                    type="number"
                    label="Qty"
                    box
                  ></v-text-field>
                </v-flex>

                <!--  Select Basket  -->
                <v-flex xs1 v-if="product_type_need_basket === true">
                  <v-autocomplete
                    v-model="basket_need"
                    :items="basket_needList"
                    item-text="text"
                    item-value="value"
                    v-on:keyup.enter="BasketNext()"
                    label="Basket"
                    ref="basket"
                    chips
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs1>
                  <v-btn color="primary" @click="additemToPO(),tabNext()">
                    <v-icon>subdirectory_arrow_left</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>

              <!-- do item local table -->
              <v-layout>
                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="local_po_stock"
                    disable-initial-sort
                    :rows-per-page-items="[100, 150, 200, 250]"
                    class="elevation-1"
                    height="60px"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          <v-avatar size="38">
                            <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
                          </v-avatar>
                        </td>
                        <td class="text-xs-right">{{ props.item.product_name }}</td>
                        <td class="text-xs-right">{{ props.item.grade }}</td>
                        <td class="text-xs-right">{{ props.item.location }}</td>
                        <td class="text-xs-right">{{ props.item.quantity }}</td> 

                        <td class="text-xs-right">{{ props.item.weight }}</td>
                        <td class="text-xs-right">{{ props.item.price }}</td>
                        <td width="10%" class="text-xs-right">
                          <v-checkbox v-if="props.item.type=='basket'" v-model="props.item.basket" label="basket"></v-checkbox>
                        </td>
                        <td class="text-xs-right">
                          <v-icon
                            medium
                            color="warning"
                            @click="edit(local_po_stock.map(function(x) {return x.product_image; }).indexOf(props.item.product_image))"
                          >build</v-icon>
                          <v-icon
                            medium
                            color="error"
                            @click="deletePOitem(props.item)"
                          >delete_forever</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-row>
                <v-btn
                  color="primary"
                  :loading="saving"
                  :disabled="saving"
                  @click.native="save_po"
                >Save</v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Loading Dialog when vege adding (Overlay)  -->
    <v-dialog v-model="vege_adding_loading_dialog" overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Adding Vege: {{vege_adding_loading_value}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--  Dialog for edit -->
    <v-dialog v-model="edit_vege" width="200">
      <v-card>
        <v-card-text>
          <div v-for="(item,index) in edit_vege_array" :key="index">
            <input type="text" :value="item" style="width: 40px;border:1px solid #000000;" />
            <v-icon small color="error" @click="deleted_single_edidted_vege(index)">delete_forever</v-icon>
          </div>
        </v-card-text>
        <v-card-action>
          <v-btn small color="success" @click="save_edited_vege">save</v-btn>
          <v-btn small color="warning" @click="edit_vege=false">cancel</v-btn>
        </v-card-action>
      </v-card>
    </v-dialog>

    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="1500">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>

    <v-snackbar v-model="snackbar_print" :top="true" :right="true" :timeout="60000">
      PO created. Print out now
      <!-- <v-btn color="success" flat @click="fetch_po_detail(po_id_print)">Print</v-btn> -->
      <v-btn color="pink" flat @click="snackbar_print = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
//import VWidget from "@/components/user_widget/vwidget";
//import delivery_order_list from "@/components/large_component/delivery_order_list";

export default {
  components: {
    //VWidget,
  },
  data() {
    return {
      //fixed
      baseUrl: baseUrl,

      //array
      farmerList: [],
      driverList: [],
      productList: [],
      farmerList_WithSelectedProduct: [],
      gradeList: [],
      locationList: [],
      local_po_stock: [],
      edit_vege_array: [],
      headers: [
        { text: "Image", value: "product_image" },
        { text: "Veg", align: "right", value: "product_name" },
        { text: "Grade", align: "right", value: "grade" },
        { text: "Location", align: "right", value: "location" },
        { text: "Qty", align: "right", value: "quantity" },

        { text: "Weight/Box", align: "right", value: "weight" },
        { text: "RM", align: "right", value: "price" },
        { text: "Actions", align: "right", value: "", sortable: false }
      ],
      po_array_for_print: [],
      new_local_po_stock: [],
      po_stock_weight_array: [],
      basket_needList: [
        { text: "basket", value: true },
        { text: "no basket", value: false }
      ],
      //main value
      date: moment().format("YYYY-MM-DD"),
      farmer: "",
      driver: "",
      product: "",

      weight: "",
      quantity: "",
      price: "",
      grade: "",
      location: "",
      basket_control_type: "driver_send",
      basket_quantity: "",
      sewa: "",
      ref_invoice:"",

      basket: true,
      basket_need: "",

      //logic control
      product_type_need_weight: true,
      product_type_need_basket: true,
      setting_grade: true,
      setting_location: true,
      setting_price: true,
      saving: false,

      //others
      response_detail: "",
      vege_adding_loading_value: "",
      VegeLogo: "",

      // dialog snackbar date_box
      edit_vege: false,
      snackbar_print: false,
      setting_dialog: false,
      date_box: false,
      vege_adding_loading_dialog: false,
      snackbar_response: false,
      snackbar_no_connection: false
    };
  },
  created() {
    this.getFarmer();
    this.getDriver();
    this.getProduct();
    this.getGrade();
    this.getLocation();
    this.getImageLogo();
  },
  mounted() {
    this.intervalFetch();
  },
  computed: {},

  methods: {
    getFarmer() {
      const params = new URLSearchParams();
      params.append("get_farmer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_farmer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.farmerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Farmer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getDriver() {
      const params = new URLSearchParams();
      params.append("get_driver", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_driver.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.driverList = response.data.data;
          } else if (response.data.error == true) {
            console.log(" Driver List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getGrade() {
      const params = new URLSearchParams();
      params.append("get_grade", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.gradeList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Grade List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getLocation() {
      const params = new URLSearchParams();
      params.append("get_location", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.locationList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Location List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    save_po() { 
      this.saving = true;

      //checking whether data filled
      if (this.date && this.farmer.id && this.local_po_stock.length > 0) {
        const params = new URLSearchParams();
        params.append("create_po", "create_po");
        params.append("date", this.date);
        params.append("farmer_id", this.farmer.id);
        params.append("basket_control_type", this.basket_control_type);
        params.append("basket_quantity", this.basket_quantity);

        params.append("driver_id", this.driver.id);

         var new_local_po_stock = [];

        for (var i = 0; i < this.local_po_stock.length; i++) {
          var multi_weight = this.local_po_stock[i].weight.split(",");

          this.po_stock_weight_array = [];

          for (var j = 0; j < multi_weight.length; j++) {
            this.calc(multi_weight[j]);
          }
          for (var g = 0; g < this.po_stock_weight_array.length; g++) {
            new_local_po_stock.push({
              product_image: this.local_po_stock[i].product_image,
              product_name: this.local_po_stock[i].product_name,
              product_id: this.local_po_stock[i].product_id,
              grade: this.local_po_stock[i].grade,
              location: this.local_po_stock[i].location,
              weight: this.po_stock_weight_array[g].weight,
              quantity: this.po_stock_weight_array[g].quantity,
              price: this.local_po_stock[i].price,
              type: this.local_po_stock[i].type,
              basket: this.local_po_stock[i].basket
            });
          }
        }
        console.log("haha");
        console.log(new_local_po_stock);
        params.append("po_item_array", JSON.stringify(new_local_po_stock));
        params.append("sewa", this.sewa);
        params.append("ref_invoice", this.ref_invoice);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
          data: params
        })
          .then(response => {
            if (response.data.error == false) {
              //set response to selected data

              this.snackbar_print = true;
              this.po_id_print = response.data.po_id;
              this.clearallfieldnew();
              this.saving = false;
              this.$emit("update", "someValue");
              // this.fetch_po_detail(this.po_id_print);
            } else if (response.data.error == true) {
              this.saving = false;

              this.snackbar_response = true;
              this.response_detail = response.data.message;
            }
          })
          .catch(error => {
            console.log(error);
            this.snackbar_connection = true;
          });
      } else {
        this.snackbar_response = true;
        this.response_detail = "Please fill in the detail & vege";
        this.saving = false;
      }
    },
    getProduct() {
      const params = new URLSearchParams();
      params.append("getAllProduct", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/product/product.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.productList = response.data.data;
            this.clearallfield();
          } else if (response.data.error == true) {
            console.log("Product List Problem" + response.data.message);
            this.clearallfield();
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    calc(weight) {
      for (var g = 0; g < this.po_stock_weight_array.length; g++) {
        if (this.po_stock_weight_array[g].weight == weight) {
          this.po_stock_weight_array[g].quantity =
            this.po_stock_weight_array[g].quantity + 1;
          return;
        }
      }

      this.po_stock_weight_array.push({
        weight: weight,
        quantity: 1
      });
    },
    additemToPO() {
      //checking whether data filled
      if (this.product.id && this.weight && this.quantity) {
        if (this.grade == "" || this.grade== null) {
          this.grade = "unknown";
        }
        if (this.location == "" || this.location== null ) {
          this.location = "unknown";
        }
        if (this.price == "" || this.price== null) {
          this.price = "0";
        }
        for (var i = 0; i < this.local_po_stock.length; i++) {
          /*
          checking input
          */

          if (
            this.local_po_stock[i].grade == this.grade &&
            this.local_po_stock[i].location == this.location &&
            this.local_po_stock[i].product_id == this.product.id &&
            this.local_po_stock[i].basket == this.basket_need &&
            this.local_po_stock[i].price == this.price
          ) {
            for (var j = 0; j < this.quantity; j++) {
              this.local_po_stock[i].weight =
                this.local_po_stock[i].weight + "," + this.weight;
                    this.local_po_stock[i].quantity++;
            }

            return;
          }
        }

        var single_weight = "";

        for (var i = 0; i < this.quantity; i++) {
          single_weight =
            (single_weight == "" ? "" : single_weight + ",") + this.weight;
        }

        this.local_po_stock.push({
          product_image: this.product.picture,
          product_name: this.product.name,
          product_id: this.product.id,
          grade: this.grade,
          location: this.location,
          weight: single_weight,
          quantity: this.quantity,
          price: parseFloat(this.price).toFixed(2),
          type: this.product.type,
          basket: this.basket_need
        });
      } else {
        this.snackbar_response = true;
        this.response_detail = "Please fill in the detail";
      }
    },
    deletePOitem(item) {
      const index = this.local_po_stock.indexOf(item);
      this.local_po_stock.splice(index, 1);
    },
    checkingProudctType() {
      // if (this.product.type == "box") {
      //   this.product_type_need_weight = false;
      //   this.weight = "1";
      // } else {
      //   this.product_type_need_weight = true;
      //   this.weight = "";
      // }
      if (this.product.type.trim() == "box" || this.product.type.trim() == "pcs" || this.product.type.trim() == "bag" || this.product.type.trim() == "pkt") {
        this.product_type_need_basket = false;
        this.basket_need = false;
        this.product_type_need_weight = false;
        this.basket = false;
        this.weight = "1";
      } else if (this.product.type.trim() == "non-basket") {
        this.product_type_need_basket = false;
        this.product_type_need_weight = true;
        this.basket_need = false;
        this.basket = false;
        this.weight = "";
      } else {
        this.product_type_need_basket = true;
        this.product_type_need_weight = true;
        this.basket_need = true;
        this.basket = true;
        this.weight = "";
      }
    },
    VegeNext() {
      // if (this.setting_grade == true) {
      //   this.$refs.grade.focus();
      //   this.$refs.grade.activateMenu();
      // } else if (this.setting_location == true) {
      //   this.$refs.location.focus();
      //   this.$refs.location.activateMenu();
      // } else if (this.product.type == "box") {
      //   this.$refs.qty.focus();
      // } else {
      //   this.$refs.weight.focus();
      // }
      if (this.setting_grade == true) {
        this.$refs.grade.focus();
        // this.grade = "unknown";
        this.$refs.grade.activateMenu();
      } 
      // else if (this.setting_location == true) {
      //   this.$refs.location.focus();
      //   this.$refs.location.activateMenu();
      //   // this.location="unknown";
      // } 
      else if (this.setting_price == true) {
        this.$refs.price.focus();
        // this.price="0";
      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    GradeNext() {
      // if (this.setting_location == true) {
      //   this.$refs.location.focus();
      //   this.$refs.location.activateMenu();
      // } else if (this.product.type == "box") {
      //   this.$refs.qty.focus();
      // } else {
      //   this.$refs.weight.focus();
      // }
      // if (this.setting_location == true) {
      //   this.$refs.location.focus();
      //   this.$refs.location.activateMenu();
      //   // this.location = "unknown";
      // } else 
      if (this.setting_price == true) {
        this.$refs.price.focus();
        // this.price="0";
      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    LocationNext() {
      // if (this.product.type == "box") {
      //   this.$refs.qty.focus();
      // } else {
      //   this.$refs.weight.focus();
      // }
      if (this.setting_price == true) {
        this.$refs.price.focus();
        // this.price="0";
      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    WeightNext() {
      this.$refs.qty.focus();
    },
    QuantityNext() {
      this.additemToPO();
      if (this.product_type_need_weight == true) {
        this.weight = "";
        this.quantity = "1";
        this.$refs.weight.focus();
      } else {
        this.quantity = "";
        this.$refs.qty.focus();
      }
    },
    PriceNext() {
      if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    nextToVege() {
      this.$refs.product.focus();
    },
    clearallfield() {
      this.farmer = "";
      this.driver = "";

      this.weight = "";
      this.quantity = "";
      this.price = "";
      this.grade = "";
    },
    clearallfieldnew() {
      this.basket_quantity = "";
      this.farmer = "";
      this.driver = "";
      this.local_po_stock = [];
      this.weight = "";
      this.quantity = "";
      this.price = "";
      this.grade = "";
    },
    intervalFetch: function() {
      setInterval(() => {
        this.setting_grade = localStorage.setting_grade;
        this.setting_location = localStorage.setting_location;
        this.setting_price = localStorage.setting_price;
        if (this.setting_grade == "true") {
          this.setting_grade = true;
        } else {
          this.setting_grade = false;
        }
        if (this.setting_location == "true") {
          this.setting_location = true;
        } else {
          this.setting_location = false;
        }

        if (this.setting_price == "true") {
          this.setting_price = true;
        } else {
          this.setting_price = false;
        }
      }, 500);
    },
    getImageLogo() {
      const toDataURL = url =>
        fetch(url)
          .then(response => response.blob())
          .then(
            blob =>
              new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
          );

      toDataURL(require("@/assets/image/vege_trading.jpg")).then(dataUrl => {
        this.VegeLogo = dataUrl;
      });
    },
    fetch_po_detail(po_id) {
      const params = new URLSearchParams();
      params.append("getPurchaseOrderByID", "getPurchaseOrderByID");
      params.append("po_id", po_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            var array = response.data.data;

            var date = array[0].created_at;
            var farmer_name = array[0].farmer_name;
            var basket_type = array[0].basket_type;
            var basket_quantity = array[0].basket_quantity;

            this.fetch_array_for_print(
              po_id,
              date,
              farmer_name,
              basket_type,
              basket_quantity
            );
          } else if (response.data.error == true) {
            // this.errors = response.data.message;
            this.po_array_for_print = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_array_for_print(
      po_id,
      date,
      farmer_name,
      basket_type,
      basket_quantity
    ) {
      const params = new URLSearchParams();
      params.append("getPOStock", "getPOStock");
      params.append("po_id", po_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.po_array_for_print = response.data.data;
            this.print_po(
              po_id,
              date,
              farmer_name,
              basket_type,
              basket_quantity
            );
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.po_array_for_print = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    print_po(po_id, date, farmer_name, basket_type, basket_quantity) {
      var doc = new jsPDF();

      doc.addImage(this.VegeLogo, 15, 10, 23, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(40, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(41, 20, localStorage.address);
      doc.text(41, 25, "Phone:" + localStorage.phone);
      doc.text(41, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(162, 15, "ID: ");
      doc.text(158, 20, "Date: ");
      doc.text(153, 25, "Farmer: ");

      if (basket_type == "Basket given") {
        doc.text(142, 40, "Basket given:  " + basket_quantity);
      } else if (basket_type == "Basket returned") {
        doc.text(137, 40, "Basket returned:  " + basket_quantity);
      }

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "#PO" + po_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(170, 20, date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(farmer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(11);
      doc.setFontStyle("normal");
      doc.text(15, 45, "Farmer Vege Date:");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(55, 45, date);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      var formatted_array = [];
      for (var i = 0; i < this.po_array_for_print.length; i++) {
        formatted_array[i] = this.po_array_for_print[i];

        this.$set(formatted_array[i], "row_no", i + 1);
      }

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        { header: "Total Weight", dataKey: "total_weight" }
      ];

      var grade_array = { header: "Grade", dataKey: "grade" };
      var location_array = { header: "Location", dataKey: "location" };

      if (localStorage.setting_location == "true") {
        invoice_pdf_header.splice(2, 0, location_array);
      }
      if (localStorage.setting_grade == "true") {
        invoice_pdf_header.splice(2, 0, grade_array);
      }

      doc.autoTable({
        pageBreak: "auto",
        startY: 55,
        theme: "grid",
        showHead: "firstPage",
        didDrawPage: function(data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);
          doc.setFontStyle("normal");

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str;
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, 100, pageHeight - 10);
        },
        headStyles: {
          fillColor: [224, 224, 224],
          textColor: 10,
          fontSize: 11
        },

        columnStyles: {
          row_no: { columnWidth: 8, fontStyle: "bold" },
          product_name: { columnWidth: 25, fontStyle: "bold" },
          grade: { columnWidth: 15 },
          location: { columnWidth: 15 },
          weight: { columnWidth: 10 },
          quantity: { columnWidth: 10 },
          total_weight: { columnWidth: 15, fontStyle: "bold" }
        },
        columns: invoice_pdf_header,
        body: formatted_array
      });

      //////after auto table
      if (doc.autoTable.previous.finalY > 230) {
        doc.addPage();
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(15, 20, 192, 20);

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, 26, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(140, 37, 192, 37);

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, 42, "Name:");
        doc.text(140, 47, "Date:");
      } else {
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 25,
          192,
          doc.autoTable.previous.finalY + 25
        );

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(
          140,
          doc.autoTable.previous.finalY + 42,
          192,
          doc.autoTable.previous.finalY + 42
        );

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
        doc.text(140, doc.autoTable.previous.finalY + 52, "Date:");
      }

      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;
      invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        { header: "Total Weight", dataKey: "total_weight" }
      ];
      doc.save("PO-" + farmer_name + "-" + date + ".pdf");
    },
    tabNext() {
      this.$refs.product.focus();
      this.$refs.product.activateMenu();
      this.product = "";

      this.grade = "";
      this.location = "";
      this.basket_need = "";
      this.price = "";
      this.weight = "";
      this.quantity = "";
    },

    edit(item) {
      console.log(item);
      this.edit_vege_index = "";
      this.edit_vege_index = item;

      this.edit_vege = true;
      this.edit_vege_array = [];
      var vege_splited = [];
      vege_splited = this.local_po_stock[item].weight.split(",");

      for (var i = 0; i < vege_splited.length; i++) {
        this.edit_vege_array.push(vege_splited[i]);
      }
    },
    save_edited_vege() {
      var vege = "";
      for (var i = 0; i < this.edit_vege_array.length; i++) {
        vege = (vege == "" ? "" : vege + ",") + this.edit_vege_array[i];
      }

      this.local_po_stock[this.edit_vege_index].weight = vege;
      this.edit_vege = false;
    },
    deleted_single_edidted_vege(index) {
      this.edit_vege_array.splice(index, 1);
    }
  }
};
</script>

